import React from "react"

/**
 * Fallback rendered by ErrorBoundary when something throws a
 * ForbiddenError. The normal permission flow handles the case
 * inline in ProtectedRoute (toast + Redirect), so this should
 * essentially never render in practice. We deliberately do NOT
 * use react-router or notistack hooks here: ErrorBoundary
 * replaces the subtree on catch, so SnackbarProvider / Router
 * providers underneath are gone — using their hooks would crash
 * and leave the user on a blank screen.
 */
const ForbiddenPage = () => (
  <div
    style={{
      minHeight: "60vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "2rem",
      textAlign: "center",
    }}
  >
    <h2 style={{ color: "#0c3b6f", marginBottom: "0.5rem" }}>
      Accès non autorisé
    </h2>
    <p style={{ color: "#555", marginBottom: "1.5rem" }}>
      Vous n'avez pas accès à cette page.
    </p>
    <a
      href="/"
      style={{
        background: "#1b6fb5",
        color: "#fff",
        padding: "0.5rem 1rem",
        borderRadius: "0.5rem",
        textDecoration: "none",
      }}
    >
      Retour à l'accueil
    </a>
  </div>
)

export default ForbiddenPage
